var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12328_5781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7571 10.5025C19.7569 12.3143 21.7553 15.611 21.7388 19.3682C21.7138 25.0551 17.0829 29.6447 11.3959 29.6198C5.70904 29.5948 1.11948 24.9648 1.1443 19.2779C1.16077 15.5208 3.18719 12.2417 6.20255 10.4562C6.37794 13.2092 8.65856 15.3937 11.4582 15.4061C14.258 15.4184 16.5576 13.2539 16.7571 10.5025ZM11.5231 0.615206C13.7663 0.625038 15.5766 2.45123 15.5668 4.69449C15.5569 6.93772 13.7307 8.74801 11.4875 8.73817C9.24431 8.72826 7.434 6.90206 7.44379 4.65889C7.45362 2.41568 9.27989 0.605456 11.5231 0.615206Z",
    stroke: "black",
    strokeWidth: 1.22973,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12328_5781",
    x: -0.0000741482,
    y: 0,
    width: 22.8825,
    height: 31.2931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.528883
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.264441
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12328_5781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12328_5781",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearlogo);
export default __webpack_public_path__ + "static/media/clearlogo.047b406de7dd105894db5448d3b5b49e.svg";
export { ForwardRef as ReactComponent };